import React, { useContext } from 'react'

import { useTranslation } from 'react-i18next'

import { ProductsContext } from '../../contexts/ProductsContext'
import { Total } from './styles'

const ProductCount: React.FC = () => {
  const { t } = useTranslation(['portfolio'])
  const { loading, total, filteredTotal } = useContext(ProductsContext)

  return (
    <>
      {loading ? null : (
        <Total>
          {t('number', { number: filteredTotal })} {t('selection.of')}{' '}
          {t('number', { number: total })} {t('selection.products')}
        </Total>
      )}
    </>
  )
}

export default ProductCount
